/**
 * Old Vietnamese URLs and their English replacements (renamed 26/09/2026).
 *
 * Old links live where they cannot be edited: articles shared to Facebook and
 * Zalo, reminder emails already sent, bookmarks. The Worker answers them with
 * a 301 and the SPA maps them the same way for in-app navigation, both from
 * this one table.
 */
const RENAMES = [
    ['/tin-tuc', '/news'],
    ['/dang-nhap', '/login'],
    ['/create', '/create-bill'],
    ['/thong-bao', '/notifications'],
    ['/bai-viet', '/posts'],
    ['/noi-dung', '/site-content'],
];
/** The new path for an old one (sub-paths included), or null if it is not an old path. */
export function legacyPath(pathname) {
    for (const [from, to] of RENAMES) {
        if (pathname === from || pathname === `${from}/`)
            return to;
        if (pathname.startsWith(`${from}/`))
            return to + pathname.slice(from.length);
    }
    return null;
}
/** Landing-page section anchors, old → new. A fragment never reaches the server, so the page maps these. */
export const LEGACY_ANCHORS = {
    've-hbac': 'about',
    'hoat-dong': 'activities',
    'tin-tuc': 'news',
    'tuyen-thanh-vien': 'join',
    'lien-he': 'contact',
};
/**
 * News filter in the URL (?category=…), in English. The stored category
 * values stay as they are; only the address changes.
 */
export const CATEGORY_SLUGS = {
    'tin-tuc': 'news',
    'thong-bao': 'announcements',
    'su-kien': 'events',
};
/** Reads ?category=, accepting the English slug and, for old links, the stored value. */
export function categoryFromSlug(slug) {
    if (!slug)
        return null;
    const hit = Object.entries(CATEGORY_SLUGS).find(([value, s]) => s === slug || value === slug);
    return hit ? hit[0] : null;
}
//# sourceMappingURL=legacy-paths.js.map